export class Query {
  constructor(id, name = '', condition = 'AND', filters = [], subGroups = []) {
    this.id = id || null
    this.name = name
    this.condition = condition
    this.filters = filters
    this.subgroups = subGroups
    this.isBusy = false
  }
}

export class Pagination {
  constructor({per_page, page} = {}) {
    this.per_page = per_page || 20
    this.page = page || 0
    this.total_pages = 0
    this.total_count = 0
  }
}

export class Filters {
  constructor({sort, order, query, search_type} = {}) {
    this.sort = sort || "asc"
    this.order = order || "name"
    this.name = query || ""
    this.search_type = search_type || null
  }
}

class PaginatedResource {
  constructor(url='', pagination = {}, filters = {} ) {
    this.isBusy = false
    this.isInitiated = false
    this.sub_options = []
    this.error = null
    this.url = url
    this.is_active = false
    this.pagination = new Pagination(pagination) // it's good to have this as an object, we can easily destructure pagination
    this.filters = new Filters(filters)
  }
}

const tiersFilterData = (item) => {
  item.isInitiated = true
  item.isDraggable = false
  item.type = 'tier'
  item.sub_options = [
    { label: 'Tier 1', value: 1, type: 'tier', isDraggable: true },
    { label: 'Tier 2', value: 2, type: 'tier', isDraggable: true },
    { label: 'Tier 3', value: 3, type: 'tier', isDraggable: true },
  ]
  return item
}

/**
 * Pretty-print category names.
 *
 * @param {string} name The type we want to process.
 * @returns {string} The resulting prettified string.
 */
function prettyPrintLabel(name) {
  switch(name) {
    case "mediaSubType":
      return "Media Subtypes";
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
}

export function setSubFilters(data, projectUid) {
  return data.map(item => {
    item = {
      ...item,
      ...{
        is_active: false,
        isInitiated: false,
        isBusy: false,
        label: prettyPrintLabel(item.type),
        isDraggable: !item.url,
        sub_options: []
      },
      ...new PaginatedResource(item.url) || {} // attach pagination and filters
    }
    // hard code tier's sub_options
    if(item.type === 'tier') item = tiersFilterData(item)
    return item
  })
}

export const contentTypes = [
  'content',
  'contentNChars',
  'contentNPercentage',
  'contentNParagraph',
  'headline', 
  'textCaseInsensitive',
  'textCaseSensitive',
  'textRegexCaseInsensitive',
  'textRegexCaseSensitive',
]

export const tableHeaders = [
  { label: '', value: 'checkbox', class: 'checkbox'},
  { label: "Id", value: "id", class: "classId" },
  { label: "Name", value: "name", class: "className"},
  { label: "Created By", value: "created_by", class: "classCreatedBy"},
  { label: "Created At", value: "created_at", class: "classCreatedBy"},
  { label: "Modified By", value: "modified_by", class: "classLastModifier"},
  { label: "Modified At", value: "updated_at", class: "classLastModifier"},
  { label: "", value: null, class: "control" }
]

export const findActionTarget = (state, actionIndex, action) => {
  let target = null;
  if(actionIndex != null) target = state.actions[actionIndex]
  if(!target) state.actions.find(item => item.type === action.type);
  return target
}